/**
 * @generated SignedSource<<49e0e48b15bfece8930f4b42f05882d9>>
 * @relayHash fdc0506dbdeace065e5044d130d6e018
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/578.0.0-2026-09-17T08:13:42.063Z/CartNotificationQuery

import { ConcreteRequest } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type ImageVersionTypeName = "bgProcessed" | "datamatics" | "large" | "master" | "medium" | "oldMaster" | "original" | "placeholder" | "small" | "thumb" | "transparent" | "zoom" | "%future added value";
export type CartNotificationQuery$variables = {
  cartItemId?: number | null;
  fetchCartItem: boolean;
  fetchItem: boolean;
  itemIds?: ReadonlyArray<string | null> | null;
  userCountryCode?: string | null;
};
export type CartNotificationQuery$data = {
  readonly viewer: {
    readonly cartItem?: {
      readonly item: {
        readonly photos: ReadonlyArray<{
          readonly versions: ReadonlyArray<{
            readonly type: {
              readonly name: ImageVersionTypeName | null;
            } | null;
            readonly webPath: string | null;
          } | null> | null;
        } | null> | null;
        readonly pricing: {
          readonly netPrice: {
            readonly convertedAmountList: ReadonlyArray<{
              readonly amount: number | null;
              readonly currency: Currency | null;
            } | null> | null;
          } | null;
          readonly retailPrice: {
            readonly convertedAmountList: ReadonlyArray<{
              readonly amount: number | null;
              readonly currency: Currency | null;
            } | null> | null;
          } | null;
          readonly salePrice: {
            readonly convertedAmountList: ReadonlyArray<{
              readonly amount: number | null;
              readonly currency: Currency | null;
            } | null> | null;
          } | null;
        } | null;
        readonly skus: ReadonlyArray<{
          readonly ImageMultiSkuOverlayImageSrc: string | null;
          readonly serviceId: string | null;
        } | null> | null;
        readonly title: string | null;
      } | null;
      readonly sku: {
        readonly firstPhotoWebPath: string | null;
      } | null;
      readonly skuId: string | null;
    } | null;
    readonly items?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly photos: ReadonlyArray<{
            readonly versions: ReadonlyArray<{
              readonly type: {
                readonly name: ImageVersionTypeName | null;
              } | null;
              readonly webPath: string | null;
            } | null> | null;
          } | null> | null;
          readonly pricing: {
            readonly netPrice: {
              readonly convertedAmountList: ReadonlyArray<{
                readonly amount: number | null;
                readonly currency: Currency | null;
              } | null> | null;
            } | null;
            readonly retailPrice: {
              readonly convertedAmountList: ReadonlyArray<{
                readonly amount: number | null;
                readonly currency: Currency | null;
              } | null> | null;
            } | null;
            readonly salePrice: {
              readonly convertedAmountList: ReadonlyArray<{
                readonly amount: number | null;
                readonly currency: Currency | null;
              } | null> | null;
            } | null;
          } | null;
          readonly skus: ReadonlyArray<{
            readonly ImageMultiSkuOverlayImageSrc: string | null;
            readonly serviceId: string | null;
          } | null> | null;
          readonly title: string | null;
        } | null;
      } | null> | null;
    } | null;
  };
};
export type CartNotificationQuery = {
  response: CartNotificationQuery$data;
  variables: CartNotificationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cartItemId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchCartItem"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchItem"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cartItemId",
    "variableName": "cartItemId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageVersionType",
      "kind": "LinkedField",
      "name": "type",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
],
v11 = {
  "alias": "ImageMultiSkuOverlayImageSrc",
  "args": (v10/*:: as any*/),
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "userCountryCode",
      "variableName": "userCountryCode"
    }
  ],
  "concreteType": "ItemPricing",
  "kind": "LinkedField",
  "name": "pricing",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "netPrice",
      "plural": false,
      "selections": (v12/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "salePrice",
      "plural": false,
      "selections": (v12/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "retailPrice",
      "plural": false,
      "selections": (v12/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  (v7/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      (v8/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemSkuType",
    "kind": "LinkedField",
    "name": "skus",
    "plural": true,
    "selections": [
      (v9/*:: as any*/),
      (v11/*:: as any*/)
    ],
    "storageKey": null
  },
  (v13/*:: as any*/)
],
v15 = {
  "alias": null,
  "args": (v10/*:: as any*/),
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = [
  (v7/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      (v8/*:: as any*/),
      (v17/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemSkuType",
    "kind": "LinkedField",
    "name": "skus",
    "plural": true,
    "selections": [
      (v9/*:: as any*/),
      (v11/*:: as any*/),
      (v17/*:: as any*/)
    ],
    "storageKey": null
  },
  (v13/*:: as any*/),
  (v17/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CartNotificationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "fetchCartItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v5/*:: as any*/),
                "concreteType": "CartItem",
                "kind": "LinkedField",
                "name": "cartItem",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "item",
                    "plural": false,
                    "selections": (v14/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "kind": "LinkedField",
                    "name": "sku",
                    "plural": false,
                    "selections": [
                      (v15/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v16/*:: as any*/),
                "concreteType": "ItemsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v14/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v3/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CartNotificationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "fetchCartItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v5/*:: as any*/),
                "concreteType": "CartItem",
                "kind": "LinkedField",
                "name": "cartItem",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "item",
                    "plural": false,
                    "selections": (v18/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "kind": "LinkedField",
                    "name": "sku",
                    "plural": false,
                    "selections": [
                      (v15/*:: as any*/),
                      (v17/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v16/*:: as any*/),
                "concreteType": "ItemsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v18/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v17/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/578.0.0-2026-09-17T08:13:42.063Z/CartNotificationQuery",
    "metadata": {},
    "name": "CartNotificationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8c623578c077cd58a2fb08ba2815cb5b";

export default node;
